import { ADD_ALERT, ENABLE_DISABLE_ALERT, GET_ALERT, GET_ALERT_LIST, ALERT_COMPLETED, GET_ALERT_TRANSACTION } from "./ActionType";

const initialValue={
    alert:[],
    alerts:[],
    addAlertData:[],
    enableDisableAlertData:[],
    alertCompletedRes:[],
    alertTransaction:[],
}

export const alertReducer=(store=initialValue, {type,payload})=>{

    if(type===GET_ALERT){
        return {
            ...store,alert:  payload || [], 
        };
    }else if(type===GET_ALERT_LIST){
        return {
            ...store,alerts:  payload || [], 
        };
    }else if(type===ADD_ALERT){
        return {
            ...store,addAlertData:  payload || [], 
        };
    }else if(type===ENABLE_DISABLE_ALERT){
        return {
            ...store,enableDisableAlertData:  payload || [], 
        };
    }else if(type===ALERT_COMPLETED){
        return {
            ...store,alertCompletedRes:  payload || [], 
        };
    }else if(type===GET_ALERT_TRANSACTION){
        return {
            ...store,alertTransaction:  payload || [], 
        };
    }

    return store
}